module.exports = __webpack_public_path__ + "img/city5.f3567240.jpg";